import type { ArgsProps as NotificationArgsProps } from 'antd/es/notification';
import type { ReactNode } from 'react';

import { useNotification } from 'contexts/NotificationProvider';

type NotificationPlacement = NotificationArgsProps['placement'];

type NotificationType = 'error' | 'warning' | 'success' | 'info';

type NotificationParams = {
  kind: NotificationType;
  message: string;
  icon?: ReactNode;
  duration?: number; // Seconds, default is 4.5
  key?: string; // Only one notification with a certain key can be active at a time
  description?: ReactNode;
  placement?: NotificationPlacement;
  showProgress?: boolean;
};

export const useOpenNotification = () => {
  const api = useNotification();

  return ({
    kind,
    message,
    icon,
    duration,
    key,
    description,
    placement = 'topRight',
    showProgress = false
  }: NotificationParams) => {
    const params: NotificationArgsProps = {
      message,
      description,
      duration,
      showProgress,
      placement,
      key,
      icon
    };
    switch (kind) {
      case 'error':
        api.error(params);
        break;
      case 'warning':
        api.warning(params);
        break;
      case 'success':
        api.success(params);
        break;
      case 'info':
        api.info(params);
        break;
      default: {
        api.info(params);
        break;
      }
    }
  };
};
